"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_TYPE = void 0;
// #endregion Interfaces (1)
// #region Enums (1)
/**
 * Definition of the task types.
 * These types are used to identify the type of a task in a task event {@link ITaskEvent}.
 */
var TASK_TYPE;
(function (TASK_TYPE) {
    TASK_TYPE["AR_LOADING"] = "ar_loading";
    TASK_TYPE["ENVIRONMENT_MAP_LOADING"] = "environment_map_loading";
    TASK_TYPE["CUSTOM_CONTENT_LOADING"] = "custom_content_loading";
    TASK_TYPE["GLTF_CREATION"] = "gltf_creation";
    TASK_TYPE["GLTF_CONTENT_LOADING"] = "gltf_content_loading";
    TASK_TYPE["MATERIAL_CONTENT_LOADING"] = "material_content_loading";
    TASK_TYPE["TAG_CONTENT_LOADING"] = "tag_content_loading";
    TASK_TYPE["SDTF_CONTENT_LOADING"] = "sdtf_content_loading";
    TASK_TYPE["SESSION_CUSTOMIZATION"] = "session_customization";
    TASK_TYPE["SESSION_CREATION"] = "session_creation";
    TASK_TYPE["SESSION_OUTPUTS_UPDATE"] = "session_outputs_update";
    TASK_TYPE["SESSION_OUTPUTS_LOADING"] = "session_outputs_loading";
    TASK_TYPE["VIEWPORT_CREATION"] = "viewer_creation";
    TASK_TYPE["EXPORT_REQUEST"] = "export_request";
})(TASK_TYPE = exports.TASK_TYPE || (exports.TASK_TYPE = {}));
// #endregion Enums (1)
//# sourceMappingURL=ITaskEvent.js.map